export const config = {
    //apiUrl: 'http://localhost:5000',
    apiUrl: 'https://app.spinrisetechnologies.com/',
    //apiUrl: 'https://spinrisetest.azurewebsites.net/',
     videoExtensions:'.mp4|.wmv|.avi',
     numberOfChildAllowToAdd: 2,
};



// WEBPACK FOOTER //
// ./src/helpers/config.js